import { cn } from '@/lib/utils'

/**
 * 计算「提交审核」按钮的 className。
 *
 * 修复 BUG-3：原实现永远带 bg-background/50 border-border/50，
 * 导致启用态也呈灰色外观，违反「灰色=禁用」视觉惯例。
 *
 * 修复后：
 *   - 启用态：标准 outline 按钮，外观清晰可点
 *   - 禁用态：依赖 shadcn disabled:opacity-50 处理视觉灰化，
 *             仅额外加 text-muted-foreground 强化文字灰色
 */
export function getReviewButtonClass(reviewDisabled: boolean): string {
  return cn('h-9 shrink-0 px-3', reviewDisabled && 'text-muted-foreground')
}
